import { Footer } from "@customer-tools-web/component-header-footer";
import i18n, { I18NProps } from "@customer-tools-web/component-i18n";
import { media, Button } from "@customer-tools-web/component-ui";
import {
  withMarketConfig,
  MarketConfig,
} from "@customer-tools-web/market-extension-resolver";
import * as React from "react";
import styled from "styled-components";

import { ROUTE_URL } from "../common/const";

import errorPageImage from "./assets/errorPage.png";

type Props = {
  errorCode?: number;
  errorMessage?: string;
  errorPrompt?: string;
  withoutFooter?: boolean;
};

class NotFoundPage extends React.Component<
  I18NProps & Props & { config: MarketConfig }
> {
  render() {
    const { t, errorCode, errorMessage, errorPrompt, withoutFooter } =
      this.props;
    return (
      <>
        <Wrapper>
          <ErrorImage>
            <img src={errorPageImage} />
          </ErrorImage>
          <ErrorMessage>
            <h1>{errorMessage || t("errorPage.notFoundMessage")}</h1>
            {!!errorCode && (
              <h2 data-test="error-code">
                {t("errorPage.errorCode", { errorCode: errorCode || 404 })}{" "}
              </h2>
            )}
            <Prompt>{errorPrompt || t("errorPage.notFoundPrompt")}</Prompt>
            <Button as="a" href={ROUTE_URL.listings}>
              {t("errorPage.backButtonText")}
            </Button>
          </ErrorMessage>
        </Wrapper>
        {!withoutFooter && <Footer />}
      </>
    );
  }
}

export { NotFoundPage };

export default i18n(withMarketConfig(NotFoundPage));

const ErrorImage = styled.div`
  flex: 1;
  text-align: center;
  img {
    width: 290px;
    margin-bottom: 25px;
  }
  ${media.sm`
    img {
      width: 340px;
    }
  `};
  ${media.lg`
    img {
      width: 100%;
      margin-bottom: 0;
    }
  `};
`;
const Prompt = styled.p`
  width: 100%;
  font-size: ${(props) => props?.theme?.fontSize?.caption};
  font-weight: 400;
  color: ${(props) => props.theme.textDeepGray};
  margin-bottom: 24px;
`;
const ErrorMessage = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: center;
  padding: 0 10px;
  h1 {
    font-size: ${(props) => props?.theme?.fontSize?.title1};
    font-weight: bold;
    line-height: normal;
  }
  h2 {
    font-size: ${(props) => props?.theme?.fontSize?.title3};
    font-weight: bold;
    margin-bottom: 16px;
    color: ${(props) => props.theme.textDeepGray};
  }
  ${/* sc-selector */ Button} {
    flex: 0 0 auto;
    width: 165px;
    margin: 0 auto;
  }
  ${media.lg`
    margin-left: 30px;
    text-align: left;
    padding: 0;
    h1 {
      font-size: ${(props: any) => props?.theme?.fontSize?.display2};
    }
    ${/* sc-selector */ Button} {
      margin: 0;
    }
  `};
`;

const Wrapper = styled.div`
  display: flex;
  background-color: white;
  flex-direction: column;
  margin: 40px 10px 80px;
  ${media.sm`
    width: 100%;
    margin-top: 80px;
    margin-bottom: 348px;
  `};
  ${media.lg`
    flex-direction: row;
    width: 1140px;
    margin: 64px auto 228px;
  `};
`;
